exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stop-item[data-v-0420d72d] {\n  display: inline;\n}\n", ""]);

// exports
